import AdminLayout from "../../layout/inner-layout/AdminLayout";
import PortalLayout from "../../layout/main-layout/PortalLayout";
import { getSessionData } from "../interceptors/localStorageService";
import LoadingPage from "../../shared/common/Loader";
import { Suspense } from "react";
import {
  findMatchingPathRequirement,
  PATH_REQUIREMENTS,
} from "../../shared/constants/pathRequirement";
import { usePermissions } from "../../store/context/permission-context";
import { useFeatures } from "../../store/context/feature-context";
import { Navigate, useLocation } from "react-router-dom";

const AdminProtectedLayout = ({ element: Component, ...rest }) => {
  const sessionData = getSessionData();
  const location = useLocation();
  const { hasFeature } = useFeatures();
  const { hasPermission } = usePermissions();
  const isLoggedIn = !!sessionData;

  const Layout = isLoggedIn ? AdminLayout : PortalLayout;

  // feature and permission guard: if current path maps to a disabled feature, block access
  // const pathAllowableFeatureCodes =
  //   PATH_REQUIREMENTS[location.pathname]?.features;
  // const pathAllowablePermissionCodes =
  //   PATH_REQUIREMENTS[location.pathname]?.permissions;

  const matchedRequirement = findMatchingPathRequirement(location.pathname);
  const pathAllowableFeatureCodes = matchedRequirement?.features;
  const pathAllowablePermissionCodes = matchedRequirement?.permissions;

  // const isFeatureDisabled =
  //   pathAllowableFeatureCodes &&
  //   !pathAllowableFeatureCodes.every((featureCode) =>
  //     isFeatureEnabled(featureCode)
  //   );
  // const isPermissionDisabled =
  //   pathAllowablePermissionCodes &&
  //   !pathAllowablePermissionCodes.some((permissionCode) =>
  //     hasPermission(permissionCode)
  //   );

  const isFeatureEnabled =
    !pathAllowableFeatureCodes ||
    pathAllowableFeatureCodes.some((featureCode) => hasFeature(featureCode));

  console.log("permissionCode?? ", matchedRequirement, location.pathname, !pathAllowablePermissionCodes, pathAllowablePermissionCodes, (pathAllowablePermissionCodes ?? []).some((permissionCode) =>
    hasPermission(permissionCode)
  ));
  const isPermissionEnabled =
    !pathAllowablePermissionCodes ||
    pathAllowablePermissionCodes.some((permissionCode) =>
      hasPermission(permissionCode)
    );
  console.log("isPermissionEnabled?? ", isPermissionEnabled);
  console.log("isFeatureEnabled and isPermissionEnabled are ;", {
    path: location.pathname,
    feature: {
      isFeatureEnabled,
      pathAllowableFeatureCodes,
    },
    permission: {
      isPermissionEnabled,
      pathAllowablePermissionCodes,
    },
    // pathRequirement: PATH_REQUIREMENTS,
  });
  console.log("isFeatureEnabled && isPermissionEnabled?? ", isFeatureEnabled, isPermissionEnabled, isFeatureEnabled && isPermissionEnabled);
  if (!(isFeatureEnabled && isPermissionEnabled)) {
    return <Navigate to={isLoggedIn ? "/admin-dashboard" : "/"} replace />;
  }

  return (
    <Layout>
      <Suspense fallback={<LoadingPage />}>
        <Component {...rest} />
      </Suspense>
    </Layout>
  );
};

export default AdminProtectedLayout;


